import React from 'react';
import styled from 'styled-components';
import Loading from '@catalogo/ui-americanas-mobile-loading';
import NotFoundTerm from '@catalogo/ui-americanas-desktop-questions-and-answers-list/src/components/not-found-term';
import { Question } from './question.js';

const WrapperLoading = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  min-height: 80px;

  div:nth-child(1) {
    position: relative;
  }
`;

export const Questions = ({ productId, questions, loading, totalQuestions, totalTermFound, term, brandText }) => {
  if (loading) {
    return (
      <WrapperLoading>
        <Loading />
      </WrapperLoading>
    );
  }

  if (totalTermFound === 0 && term && totalQuestions) {
    return <NotFoundTerm productId={productId} brandText={brandText} />;
  }

  return questions.map((question, index) => (
    <Question
      key={question.id}
      question={question}
      term={term}
      totalTermFound={totalTermFound}
      isLast={questions.length - 1 === index}
    />
  ));
};
